<template>
  <div> 
    <job-header-simple header_title="个体户列表" :backRouter="'/individual_index'"></job-header-simple>
    <div class="public_empty_section message" v-if="individualBusinessList.length == 0">暂无任务</div>
    <van-list finished-text="没有更多了">
        <div class="view-box"  v-for="item in individualBusinessList" :key="item.id">
          <div @click="handleClick(item)">
            <div class="view-text">
            <p class="text-num" v-if="item.firmId">{{item.firmId}}</p>
            <p class="text-num" v-else>-</p>
            <p class="text-identify" v-if="item.status=='stay_authenticate' ">待认证</p>
            <p class="text-identify-fail"  v-if="item.status=='identity_failure' || item.status=='real_failure' || item.status=='face_success'">认证失败</p>
            <p class="text-identify" v-if=" item.status=='identity_success' " >待视频认证</p>
            <p class="text-identify" v-if="item.status=='real_success'">待申请</p>
            <p class="text-identify-fail" v-if="item.status=='face_failure' ">视频认证未通过</p>
            <p class="text-identify" v-if="item.status=='stay_audit' || item.status=='auditing'||item.status=='stay_government_audit'">审核中</p>
            <p class="text-identify-suc" v-if="item.status=='pass_audit'">注册成功</p>
            <p class="text-identify-fail" v-if="item.status=='reject_audit'">注册失败</p>

            <p class="text-identify" v-if="item.status=='company_logoff_stay_audit'||item.status=='company_logoff_reject'">政府审核通过</p>
            <p class="text-identify" v-if="item.status=='individual_logoff_stay_apply'">待注销</p>
            <p class="text-identify-fail" v-if="item.status=='individual_logoff_stay_audit'">注销待审核</p>
            <p class="text-identify-fail" v-if="item.status=='individual_logoff_reject'">注销驳回</p>
            <p class="text-identify-fail" v-if="item.status=='logoff_ing'">注销中</p>
            <p class="text-identify-suc" v-if="item.status=='logoff_complete'">已注销</p>
          </div>
          <div class="view-message" v-if="item.firmName">个体户名称：{{item.firmName}}</div>
          <div class="view-message"  v-else>个体户名称：-</div>
          <div class="view-message" v-if="item.yyzzNo">营业执照号：{{item.yyzzNo}}</div>
          <div class="view-message" v-else>营业执照号：-</div>
          <div class="view-message">服务公司：{{item.ocompanyName}}</div>
          <div class="view-message" v-if="item.registerDate">注册时间：{{item.registerDate}}</div>
          <div class="view-message" v-else>注册时间：-</div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import {
  Cell,List
} from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import api from "@/api/list";
import wx from 'weixin-js-sdk'
import { browserUA } from "@/utils/browserUA";
import {getToken} from "@/utils/auth";

export default {
  components: {
    jobHeaderSimple,
    [Cell.name]: Cell,
    [List.name]: List
  },
   data() {
      return {
          individualBusinessList:[],
          loading: false
      }
   },
   created() {
      this.getIndividualBusiness();
   },
  methods: {
    getIndividualBusiness(){
        api.getIndividualBusiness().then((res) => {
         if (res.status == "200") {
            this.individualBusinessList=res.data.data;
         }
      });
    },
    handleClick(item){
      if(item.status=='logoff_complete'){
        return;
      }
      let toUrl=null;
      if(item.status=='stay_authenticate'  || item.status=='identity_failure' || item.status=='real_failure' || item.status=='face_success'){ //跳转到身份证认证页面
          toUrl="/individual_identity";
          // 判断是否小程序
          browserUA().then((browserType) => {
            if (browserType == "MINI") { // 小程序，跳转到小程序身份认证页面
              wx.miniProgram.navigateTo({url: '/pages/individualIdentity/index?ocompanyId='+item.ocompanyId+'&token='+getToken()});
            }else{
                this.$router.push({
                  path: toUrl,
                  query: {
                      id: item.id,
                      ocompanyId:item.ocompanyId
                }
              });
            }
          })
          return;
      }
      if(item.status=='identity_success'){ //跳转到视频认证页面
          // 判断是否小程序
          browserUA().then((browserType) => {
            if (browserType == "MINI") { // 小程序，跳转到小程序拍摄页面
              wx.miniProgram.navigateTo({url: '/pages/individualVideo/index?ocompanyId='+item.ocompanyId+'&token='+getToken()});
            }else{
              this.$router.push({
                path: '/individual_video',
                query: {
                    id: item.id,
                    ocompanyId:item.ocompanyId
                }
              });
            }
          })
          return;
      }
      if(item.status=='real_success'){ //点击跳转到签名页面
          toUrl="/individual_signature";
      }
      if(item.status=='face_failure' || item.status=='stay_audit' || item.status=='auditing' || item.status=='pass_audit' || item.status=='reject_audit'|| item.status=='stay_government_audit'){ //点击跳转到个体户明细页面
          toUrl="/individual_info";
      }

      if(item.status=='company_logoff_stay_audit' 
      || item.status=='company_logoff_reject' 
      || item.status=='individual_logoff_stay_apply' 
      || item.status=='individual_logoff_stay_audit' 
      || item.status=='individual_logoff_reject'
      || item.status=='logoff_ing')
      { //点击跳转到个体户明细页面
          toUrl="/individual_info";
      }
      this.$router.push({
        path: toUrl,
        query: {
            id: item.id,
            ocompanyId:item.ocompanyId
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>

.view-box{
  background-color: #ffffff;
  border-radius: 10px;
  margin: 14px 10px;
  padding: 18px 12px;
  .view-message{
    font-size: 12px;
    color: #999;
    padding: 6px 0;
  }
  .view-text{
    display: flex;
    justify-content: space-between;
    align-items:center;
    .text-num{
      font-size: 14px;
      padding: 0.16rem 0;
    }
    .text-identify{
      font-size: 14px;
      color: #f3852c;
    }
    .text-identify-suc{
      font-size: 14px;
      color: #6c7ef3;
    }
    .text-identify-fail{
      font-size: 14px;
      color: red;
    }
  }
}
</style>
